module.exports = __webpack_public_path__ + "static/media/18.ffeff6bb.jpg";